angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when("/company/:oid/rangedefinition", {
        templateUrl: 'assets/general_conditions/rangeDefinition/rangeDefinition.html',
        controller: 'RangeDefinitionController',
        title: 'range_definition.TITLE',
        sidebar: 'generalConditions'
    }).when("/company/:oid/modificationpolicies/", {
        templateUrl: 'assets/general_conditions/modificationPolicy/modificationpolicies.html',
        controller: 'ModificationPoliciesController',
        title: 'modification_policies.TITLE',
        sidebar: 'generalConditions'
    }).when("/company/:oid/oneway", {
        templateUrl: 'assets/general_conditions/oneWay/oneway.html',
        controller: 'OneWayController',
        title: 'oneWay.TITLE',
        sidebar: 'generalConditions'
    }).when("/company/:oid/additionalPrice", {
        templateUrl: 'assets/general_conditions/additionalPrice/additionalPrice.html',
        controller: 'AdditionalsPriceController',
        title: 'additionalPrice.TITLE',
        sidebar: 'generalConditions'
    }).when("/company/:oid/insurancePrice", {
        templateUrl: 'assets/general_conditions/insurancePrice/insurancePrice.html',
        controller: 'InsurancesPriceController',
        title: 'insurancePrice.TITLE',
        sidebar: 'generalConditions'
    })
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/routes/generalConditions_route.js
// module id = 813
// module chunks = 3